module.exports = __webpack_public_path__ + "img/0-02-0a-b8794431c93fc1216ec4d0eda71c24793f75f7bb69b74d9154b098ea5f3dcc03_29b2807f.540b4866.jpg";